import { Component, inject, OnInit, signal } from "@angular/core";
import { SidebarService } from "../../services/sidebar.service";
import { ButtonModule } from "primeng/button";
import { assets } from "../../core/constants/assets.const";
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { RouterModule } from "@angular/router";
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Subject, Subscription, takeUntil } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { LoginResponse } from "../../models/auth.model";
import { NotificationService } from "../../services/notification.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BaseClass } from "../class/baseClass";
import { LangValuePipe } from "../../core/pipe/lang-handler.pipe";



@Component({
  selector: "top-technology-header",
  standalone: true,
  imports: [ButtonModule, Menu, RouterModule, OverlayPanelModule, TranslateModule, LangValuePipe],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class HeaderComponent extends BaseClass implements OnInit {
  assetsConst = assets;
  items: MenuItem[] | undefined;
  currentLang = 'EN';
  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected profile: LoginResponse | null = null;
  private notificationService = inject(NotificationService);
  private authService = inject(AuthService);
  protected notificationList = signal<any[]>([]);

  constructor(private sidebarService: SidebarService,
    private translate: TranslateService,
    private _authService:AuthService) { 
      super();
      this.currentLang = localStorage.getItem('language') || 'EN'
      this.currentLang = this.currentLang.toUpperCase();
      if(this.currentLang === 'AR') {
        document.dir = this.currentLang === 'AR' ? 'rtl' : 'ltr';
    document.querySelector('html')?.setAttribute('lang', this.currentLang);
      }
    }

  navigateToNotifications(op: OverlayPanel) {
    op.hide(); // Close the overlay panel
    this.router.navigate(['/received-notifications']); // Navigate to the page
  }
  sidebarOnOff(): void {
    this.sidebarService.toggleSidebar();
  }

  ngOnInit() {
    this.items = [
      {
        label: 'English',
        command: () => this.changeLang('en')
      },
      {
        label: 'Français',
        command: () => this.changeLang('fr')
      },
      {
        label: 'العربية',
        command: () => this.changeLang('ar')
      }
    ];

    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.profile = res;
        } else {
          this.getProfile();
        }
      });
      this.NotificationData();
  }

    getProfile(): void {
    this._authService
      .getProfile()
      .pipe(takeUntil(this.destroy))
      .subscribe((res: LoginResponse | null) => {
        if (res) {
          this.profile = res; 
        }
      });
  }

  protected NotificationData():void {
    const body = {
      start: 1,
      length: 3,
    };
    this.notificationService.getAdminNotification(body).pipe(takeUntilDestroyed(this.destroyRef$)).subscribe({
        next:(res:any)=> {
            this.notificationList.set(res.response_object);
        }
    })
}
  
  changeLang(lang: string) {
    this.updateLanguagePreference(lang)
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.currentLang = lang.toUpperCase();
    document.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.querySelector('html')?.setAttribute('lang', lang);
  }

  updateLanguagePreference(lang:string):void {
    const data = {
      language:lang
    };
    this.authService
      .updateProfile(data)
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe(() => {
        //
      });
  }
}
